import { useState } from 'react';

// StepOne Component
function StepOne({ onSave }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    age: '',
    marketing: false
  });
  const [errors, setErrors] = useState({});

  const validateForm = async () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Please enter your name';
    }
    
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    if (!formData.age) {
      newErrors.age = 'Please enter your age';
    } else {
      const age = parseInt(formData.age);
      if (isNaN(age)) {
        newErrors.age = 'Please enter a valid number';
      } else if (age < 18) {
        newErrors.age = 'You must be at least 18 years old';
      } else if (age > 120) {
        newErrors.age = 'Please enter a valid age';
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  if (typeof window !== 'undefined') {
    window.step1Methods = {
      validateForm,
      getFormData: () => formData
    };
  }

  return (
    <div className="max-w-2xl mx-auto">
      {/* Name Field */}
      <div className="mb-6">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          What should we call you?
        </label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({...formData, name: e.target.value})}
          placeholder="Enter your name"
          maxLength={50}
          className={`w-full px-4 py-3 rounded-lg border-2 transition-colors ${
            errors.name ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'
          } focus:outline-none`}
        />
        {errors.name && <p className="mt-1 text-sm text-red-500">{errors.name}</p>}
        <p className="mt-2 text-sm text-gray-600">
          We use your name to personalise your experience. Feel free to leave this blank if you'd rather not share.
        </p>
      </div>

      {/* Email Field */}
      <div className="mb-6">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Your Email Address
        </label>
        <input
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          placeholder="Enter your email address (optional)"
          className={`w-full px-4 py-3 rounded-lg border-2 transition-colors ${
            errors.email ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'
          } focus:outline-none`}
        />
        {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
        <p className="mt-2 text-sm text-gray-600">
          We'll use this to save your progress and send your personalised results. We won't contact you unless you allow it.
        </p>
      </div>

      {/* Age Field */}
      <div className="mb-6">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          How old are you?
        </label>
        <input
          type="number"
          value={formData.age}
          onChange={(e) => setFormData({...formData, age: e.target.value})}
          placeholder="Enter your age (years)"
          min={18}
          max={120}
          className={`w-full px-4 py-3 rounded-lg border-2 transition-colors ${
            errors.age ? 'border-red-500' : 'border-gray-300 focus:border-blue-500'
          } focus:outline-none`}
        />
        {errors.age && <p className="mt-1 text-sm text-red-500">{errors.age}</p>}
        <p className="mt-2 text-sm text-gray-600">
          Providing your age helps us tailor your assessment and results.
        </p>
      </div>

      {/* Marketing Checkbox */}
      <div className="mb-6">
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={formData.marketing}
            onChange={(e) => setFormData({...formData, marketing: e.target.checked})}
            className="mt-1 w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700">
            Yes, I'd like to receive helpful updates & mental health-related insights.
          </span>
        </label>
        <p className="mt-2 ml-8 text-sm text-gray-600">
          We respect your privacy. You can unsubscribe anytime. Review our Privacy Policy and Terms & Conditions.
          Any shared research data is anonymised and never linked back to you.
        </p>
      </div>
    </div>
  );
}

export default StepOne;